<template>
  <div class="home-search">
    <div
      class="s-content"
      @click="bindClick"
      v-clickBuried
      data-click-buried="CLICK_BUJILIEBIAO_SOUSUO"
    >
      <div class="iconfont icon-sousuo"></div>
      <div class="s-center">
        <van-swipe
          class="my-swipe"
          vertical
          :autoplay="3000"
          :show-indicators="false"
          @change="bindChange"
          :touchable="false"
        >
          <van-swipe-item v-for="(item, index) in hot" :key="index">
            <div class="search-word">{{ item }}</div>
          </van-swipe-item>
        </van-swipe>
      </div>
      <div class="s-text" @click.stop="bindTab">搜索</div>
    </div>
  </div>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      active: 0,
      hot: []
    }
  },
  created() {
    this.getHotData()
  },
  methods: {
    bindChange(index) {
      this.active = index
    },
    bindClick() {
      this.$emit('tab', this.hot[this.active])
    },
    bindTab() {
      this.$emit('search', this.hot[this.active])
    },
    async getHotData() {
      let res = await this.$http
        .postBaseApp('api/v1/TonicShow/hotKeywords', {})
        .catch(() => {})
      if (res) {
        res = res.data
        if (res.code == 200) {
          this.hot = res.data || []
        }
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.home-search {
  padding: 10px 16px;

  .s-content {
    height: 34px;
    background: #ffffff;
    border-radius: 17px;
    border: 1px solid rgba(0, 205, 223, 1);
    display: flex;
    align-items: center;
    padding: 0px 4px 0px 13px;

    .iconfont {
      font-weight: bold;
      font-size: 20px;
      color: #d1d1d3;
      margin-right: 6px;
    }

    .s-center {
      flex: 1;
      flex-shrink: 0;
      overflow: hidden;

      .my-swipe {
        height: 34px;

        .search-word {
          height: 100%;
          display: flex;
          align-items: center;
          white-space: nowrap;
          text-overflow: ellipsis;
          color: rgba(0, 0, 0, 0.6);
          overflow: hidden;
        }
      }
    }

    .s-text {
      height: 26px;
      background: linear-gradient(
        269deg,
        #6dfdc7 0%,
        #3edcf3 26%,
        #3cb6ff 100%
      );
      border-radius: 13px;
      padding: 0px 12px;
      font-weight: bold;
      font-size: 12px;
      color: #ffffff;
      line-height: 26px;
    }
  }
}
</style>
